import ReduxThunk from 'redux-thunk'

export default [ReduxThunk]
